import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can sync data from TikTok Ads reports by configuring it as a source in PostHog. The supported reports that can be synced include Ad Groups, Campaigns, Ads, Ad Group Report, Campaign Report, and Ad Report, as described here:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business-api.tiktok.com/portal/docs?id=1739314558673922"
        }}>{`Ad Groups`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business-api.tiktok.com/portal/docs?id=1739315828649986"
        }}>{`Campaigns`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business-api.tiktok.com/portal/docs?id=1735735588640770"
        }}>{`Ads`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business-api.tiktok.com/portal/docs?id=1740302848100353"
        }}>{`Ad Groups Report`}</a>{`: Filter by `}<inlineCode parentName="li">{`adgroup_ids`}</inlineCode></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business-api.tiktok.com/portal/docs?id=1740302848100353"
        }}>{`Campaign Report`}</a>{`: Filter by `}<inlineCode parentName="li">{`campaign_ids`}</inlineCode></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business-api.tiktok.com/portal/docs?id=1740302848100353"
        }}>{`Ad Report`}</a>{`: Filter by `}<inlineCode parentName="li">{`ad_ids`}</inlineCode></li>
    </ul>
    <p>{`Additional reports will be added based on user feedback we receive via our `}<a parentName="p" {...{
        "href": "https://app.posthog.com/#panel=support%3Afeedback%3Adata_warehouse%3Alow%3Atrue"
      }}>{`in-app support form`}</a>{`.`}</p>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`A TikTok Ads account with permission to access data from accounts you want to sync.`}</li>
      <li parentName="ul">{`Your account ID from the `}<a parentName="li" {...{
          "href": "https://ads.tiktok.com/i18n/dashboard"
        }}>{`ads manager`}</a>{` > in the top right it's your account > open the dropdown > check your ad account ID or check the dashboard url, e.g `}<inlineCode parentName="li">{`https://ads.tiktok.com/i18n/dashboard?aadvid=ID_HERE`}</inlineCode></li>
    </ul>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/w_500,c_limit,q_auto,f_auto/Screenshot_2025_09_30_at_11_25_16_AM_ab70c4f7c4.png" classes="rounded" alt="Tiktok account ID" mdxType="ProductScreenshot" />
    <h2 {...{
      "id": "configuring-posthog"
    }}>{`Configuring PostHog`}</h2>
    <p>{`Connect PostHog to your TikTok Ads account. The TikTok account must have permission to access data.`}</p>
    <ol>
      <li parentName="ol">{`In PostHog, go to the `}<strong parentName="li"><a parentName="strong" {...{
            "href": "https://app.posthog.com/pipeline/sources"
          }}>{`Data pipelines`}</a></strong>{` tab.`}</li>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`+ New`}</strong>{` drop-down menu in the top-right and select `}<strong parentName="li">{`Source`}</strong>{`.`}</li>
      <li parentName="ol">{`Find Tiktok Ads in the sources list and click `}<strong parentName="li">{`Link`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter the `}<strong parentName="li">{`Account ID`}</strong>{` of the Tiktok Ads account you want to sync.`}</li>
      <li parentName="ol">{`Select an existing TikTok Ads account, or create a new integration.`}</li>
      <li parentName="ol">{`(Optional) Add a prefix for the table name.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      